import React, { useEffect, useRef, useState } from 'react';

// Renders children only once the placeholder is close to the viewport.
// Swiper measures the layout (clientWidth, offsetWidth, getComputedStyle) as soon as it mounts, which forces a
// reflow during the first render; below-the-fold sliders don't need to pay that cost until the user scrolls to them.
function MountWhenNear({ children, minHeight, rootMargin = '400px 0px' }) {
	const [near, setNear] = useState(typeof IntersectionObserver === 'undefined');
	const placeholderRef = useRef(null);

	useEffect(() => {
		if (near) return;
		const el = placeholderRef.current;
		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				setNear(true);
				observer.disconnect();
			}
		}, { rootMargin });
		observer.observe(el);
		return () => observer.disconnect();
	}, [near, rootMargin]);

	if (near) return children;
	return <div ref={placeholderRef} style={{ minHeight }} />;
}

export default MountWhenNear;
